import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const first = document.getElementById('first-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-148" data-mp="bq9furzo3c1a">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-149" data-mp="195wrtb2xzn8w">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex max-w-md items-center justify-center gap-2.5 rounded-2xl border-2 border-white/30 bg-cta px-5 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_rgba(11,27,51,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold" data-id="element-150" data-mp="2f40z89abstp4">
            <ShoppingCartIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-151" data-mp="1rgkkk9fzgxgn" />
            <span data-id="element-152" data-mp="1wf43s236zv5b">Get It Now — Only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}